export default __webpack_public_path__ + "static/media/black.4679c529.jpg";